;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { useEffect, useRef } from 'react'

/**
 * Implements the latest ref pattern. Allows you to access the latest value of a variable from inside an async callback.
 * 
 * @example
 * const formErrors = form.formState.errors
 * const latestFormErrorsRef = useLatestRef(formErrors)
 * async function submitAction() {
 *   await form.trigger() // This will validate the form and update the errors state
 *   // But here we can't access the errors state directly because of the stale closure problem, 
 *   // it would be the value of the errors from before the callback started
 *   // We can use the latest ref to access the latest value of the errors state instead
 *   const latestErrors = latestFormErrorsRef.current
 *   // And we can log the latest value
     console.log(latestErrors)
 * }
 * 
 * @see https://www.epicreact.dev/the-latest-ref-pattern-in-react
 */
export function useLatestRef<T>(initialValue: T) {
  const ref = useRef(initialValue)
  useEffect(() => {
    ref.current = initialValue
  }, [initialValue])
  return ref
}
